import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/internal/Observable';
import { ListConductivityprofiles } from 'src/app/models/conductivityprofiles.model';
import { Plant } from 'src/app/models/plant.model';
import { Train } from 'src/app/models/train.model';
import { ConductivityprofilesService } from 'src/app/services/conductivityprofiles/conductivityprofiles.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';

@Component({
  selector: 'app-list-conductivityprofiles',
  templateUrl: './list-conductivityprofiles.component.html',
  styleUrls: ['./list-conductivityprofiles.component.scss'],
})
export class ListConductivityprofilesComponent {
  constructor(
    private trainService: TrainService,
    private plantService: PlantsService,
    private conductivityprofilesservice: ConductivityprofilesService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  dtoptions: DataTables.Settings = {};
  plants: Plant[] = [];
  trains: Train[] = [];

  ListConductivityprofiles: ListConductivityprofiles[] = [];
  SelectedId: string;
  trainId: string;
  plantDetails: Plant = new Plant();
  trainDetails: Train = new Train();
  tableData: any;

  loggedInUserRole:string;
  loggedinUserId:string;
  plantAndUserId:string;
  trainId$: Observable<any[]>;
  plantId$: Observable<any[]>;
  

  getSelectedId(e) {
  
    this.SelectedId = e.target.value;
    if(this.loggedInUserRole =='Standard User')
      {
    this.plantAndUserId = this.SelectedId + 'Z' + this.loggedinUserId;
    this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId)
      
      .subscribe(
        (response: Train[]) => {
          this.trains = response;
        },
        (error: any) => {
          console.log('error list');
        }
      );
  }
  else
  {
    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },
      (error: any) => {
        console.log('error list');
      }
    );
  }
}

  getSelectedTrainId(e) {
    this.SelectedId = e.target.value;
    this.trainId = this.SelectedId
    this.getConductivityprofilesData(this.trainId)
  }

  getConductivityprofilesData(TrainId){
    this.ListConductivityprofiles.length = 0;
    this.conductivityprofilesservice
      .getConductivityprofilesListByTrainId(TrainId)
      .subscribe((response: ListConductivityprofiles[]) => {
        this.ListConductivityprofiles = response;
        console.log(this.ListConductivityprofiles);
        const formattedData = this.ListConductivityprofiles.map((item) => ({
          stage: `Stage ${item.Stage}`,
          pvId: item.PvId,
          date: item.TableshortcodeDatetime,
          value: item.PermCond || '-',
        }));

        formattedData.sort(
          (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
        );

        const transformedData = formattedData.reduce((acc, curr) => {
          const existingItem = acc.find(
            (item) => item.stage === curr.stage && item.pvId === curr.pvId
          );
          if (existingItem) {
            existingItem[curr.date] = curr.value || '-';
          } else {
            const newItem = {
              stage: curr.stage,
              pvId: curr.pvId,
              [curr.date]: curr.value || '-',
            };
            acc.push(newItem);
          }
          return acc;
        }, []);
        console.log(transformedData);
        this.tableData = transformedData;
      });
  }

  isDate(value: unknown): boolean {
    return typeof value === 'string' && !isNaN(Date.parse(value as string));
  }

  distinctDates(data: any[]): string[] {
    const dates = new Set<string>();
    data.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (this.isDate(key)) {
          dates.add(key);
        }
      });
    });
    return Array.from(dates);
  }

  deleteConductivityprofileByTrainId() {
    const confirmDelete = confirm(
      'Are you sure you want to delete all Conductivity Profiles for this Train?'
    );

    if (!confirmDelete) {
      return; 
    }

    this.conductivityprofilesservice.deleteConductivityprofilesByTrainId(+this.trainId)
      .subscribe((response: Response) => {
        if (response.statusText == 'Success') {
          this.toastr.error('Conductivity Profile Deleted successfully.', 'Information');
          this.getConductivityprofilesData(this.trainId)
        } else {
          (error) => {
            console.log('Error deleting Conductivity Profile:', error);
          };
        }
      });
  }

  ngOnInit(): void {
    this.dtoptions = {
      pagingType: 'full_numbers',
      order: [[0, 'asc']],
      columnDefs: [{width: '10%' , targets:0}],
      
    };

    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;
      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
      
    }
    else
    {
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }
    //load data using plantId from breadcrumbs
    this.conductivityprofilesservice.plantId$.subscribe(plantId => {
      if (plantId) {
          this.getSelectedId({ target: { value: plantId } });
      }
    });

    //load data using trainid from breadcrumbs
    this.conductivityprofilesservice.trainId$.subscribe(trainId => {
      if (trainId) {
          this.getSelectedTrainId({ target: { value: trainId } });
      }
    });
  }
}
